<header class="header-area p-relative">
    <div class="top-header top-header-style-four">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-10 col-md-10">
                    <ul class="top-header-contact-info">
                        <li>
                            <a href="tel:0212302980">
                                <i class="bx bx-phone-call"></i>
                                021 230 29 80
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="bx bx-map"></i>
                                Str. Washington 8–10, Bucuresti</a
                            >
                        </li>
                        <li>
                            <a href="mailto:office@cmdtamp.ro">
                                <i class="bx bx-envelope"></i>
                                office@cmdtamp.ro
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="col-lg-2 col-md-2" style="font-size: 15px">
                    <ul class="top-header-login-register">
                        <li *ngIf="!isLogged()">
                            <a routerLink="/login"
                                ><i class="bx bx-log-in"></i> Acces membri</a
                            >
                        </li>
                        <li *ngIf="isLogged()">
                            <a routerLink="/contul-meu"
                                ><i class="bx bx-log-in"></i> Cont</a
                            >
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div
        class="navbar-area navbar-style-three"
        ngStickyNav
        stickyClass="sticky-box-shadow"
        ngStickyNav
    >
        <div class="container">
            <nav
                class="navbar navbar-expand-lg navbar-light bg-light"
                [class.active]="classApplied"
            >
                <a class="navbar-brand" routerLink="/"
                    ><img src="assets/img/black-logo.png" alt="logo"
                /></a>
                <button
                    class="navbar-toggler"
                    type="button"
                    (click)="toggleClass()"
                >
                    <span class="burger-menu">
                        <span class="top-bar"></span>
                        <span class="middle-bar"></span>
                        <span class="bottom-bar"></span>
                    </span>
                </button>
                <div
                    class="collapse navbar-collapse"
                    id="navbarSupportedContent"
                >
                    <ul class="navbar-nav">
                        <!-- <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Acasa</a></li>-->
                        <li class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"
                                >Despre noi <i class="bx bx-chevron-down"></i
                            ></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a
                                        routerLink="/despre-noi"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Despre CMDTAMP</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/situatie-drepturi-salariale"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Situatie drepturi salariale</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/echipa"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Echipa</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/achizitii-si-licitatii"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Licitatii si Achizitii</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/access-mass-media"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Acces Mass-Media in CMDTAMP</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/declaratii-de-avere-si-interese"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Declaratii de avere si interese</a
                                    >
                                </li>

                                <!-- <li class="nav-item"><a routerLink="/conducere-si-acces" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Conducere si acces CMDTAMP</a></li> -->
                            </ul>
                        </li>
                    
                        <li class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"
                                >Specialitati Medicale
                                <i class="bx bx-chevron-down"></i
                            ></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a
                                        routerLink="/specialitati-medicale"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Specialitati Medicale</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/legislatie-cadre-medicale"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Legislatie cadre medicale</a
                                    >
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"
                                >Servicii&Tarife
                                <i class="bx bx-chevron-down"></i
                            ></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a
                                        routerLink="/tarife-servicii"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Tarife servicii</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/servicii-decontate"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Servicii decontate</a
                                    >
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"
                                >Pentru pacienti
                                <i class="bx bx-chevron-down"></i
                            ></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a
                                        routerLink="/anunturi"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Anunturi</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/contul-meu"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Programare Online</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/coronavirus"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >COVID-19</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/drepturi-si-obligatii"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Drepturi si Obligatii
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/politica-gdpr"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Politica GDPR
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/creare-cont"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Creare Cont
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/servicii-pentru-pacienti"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Servicii pentru pacienti
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/preventie-si-stil-de-viata-sanatos"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Preventie si stil de viata sanatos</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/legislatie"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Legislatie</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/formular-de-evaluare"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Formular Satisfactie</a
                                    >
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item">
                            <a
                                routerLink="/cariere"
                                class="nav-link"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                >Cariere</a
                            >
                        </li>
                        <li class="nav-item">
                            <a
                                routerLink="/contact"
                                class="nav-link"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                >Contact</a
                            >
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</header>

<div class="search-overlay" [class.active]="classApplied3">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-close" (click)="toggleClass3()">
                <span class="search-overlay-close-line"></span>
                <span class="search-overlay-close-line"></span>
            </div>
            <div class="search-overlay-form">
                <form>
                    <input
                        type="text"
                        class="input-search"
                        placeholder="Search here..."
                    />
                    <button type="submit">
                        <i class="bx bx-search-alt"></i>
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>
